// extracted by mini-css-extract-plugin
export default {"container":"JackpotBox_container__pQtLR","normal":"JackpotBox_normal__-zTjh","tiny":"JackpotBox_tiny__Ofx61","nextContainer":"JackpotBox_nextContainer__QBUcQ"};